import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './themes/default.less';
import './index.less';


export default class ControlData extends MainComponent {
    static propTypes = {
        defaultMode: PropTypes.number,
        items: PropTypes.array,
        onClick: PropTypes.function,
    };
    static defaultProps = {
        defaultMode: 0,
        items: [],
        onClick: null,
    };

    onClick(i) {
        if (this.props?.onClick?.apply)
            this.props.onClick(i);
    }

    render() {
        const { defaultMode, items } = this.props;

        return (<div className="wrapControlData flex gap8 rad8 text p1SemiBold">
            {items.map((it, i) => (<div
                key={"controlData" + i}
                className={`contolDateItem rad8 ${i === defaultMode ? "active" : ""}`}
                onClick={this.onClick.bind(this, i)}>
                {this._helper.string.capitalize(this.tr(it))}
            </div>))}
        </div>);
    }
}

